export default __webpack_public_path__ + "images/plot-type-clustered-bar.1eef9ab091f503c92776fe17cdeba924.svg";